import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { PropType as PolygotPropType } from 'redux-polyglot';
import { Line } from 'components/Charts';
import { autobind } from 'core-decorators';
import { Skeleton, Alert } from 'antd';
import moment from 'moment';
import { formatDwellTime } from '../../formatHelpers';
import CMSReport from '../../../Providers/CMSReportProvider';

class CMSDwelltime extends Component {
  @autobind
  renderData(canvas) {
    const { dimensions, result, p } = this.props;
    const ctx = canvas.getContext('2d');
    const gradient = ctx.createLinearGradient(0, 0, 0, 315);
    gradient.addColorStop(0, 'rgba(255, 183, 77, .2)');
    gradient.addColorStop(0.6, 'rgba(255, 183, 77, 0)');

    const xfmt = ['minute', 'hour'].includes(dimensions) ? (x => moment(x[0]).toDate()) : (x => moment(x[0].slice(0, 19)).toDate());
    const data = result && result.content && result.content.rows ? [...result.content.rows]
      .sort((a, b) => a[0].localeCompare(b[0])) : [];
    const labels = data.map(xfmt);
    const datasets = [{
      label: p.tt('dwell_time'),
      data: data.map(x => x[1]),
      backgroundColor: gradient,
      borderColor: '#FFB74D',
      pointBackgroundColor: '#FFB74D',
      borderWidth: 2,
      pointRadius: data.length > 30 ? 0 : undefined,
    }];
    return {
      labels,
      datasets,
    };
  }

  render() {
    const {
      fetching,
      failed,
      error,
      result,
      p,
      dimensions,
      noData,
    } = this.props;
    if (fetching && (!result || !result.content
        || !result.content.rows || !result.content.rows.length)) {
      return <Skeleton active />;
    }
    if (failed || error) {
      return <Alert message={p.t('errors.loading', { error })} type="error" />;
    }
    return (
      <div className="reporting-charts">
        <Line
          data={noData ? {} : this.renderData}
          yFmtr={formatDwellTime}
          xTimeUnit={['minute', 'hour'].includes(dimensions) ? undefined : 'day'}
          mode="nearest"
        />
      </div>
    );
  }
}

CMSDwelltime.propTypes = {
  fetching: PropTypes.bool,
  failed: PropTypes.bool,
  error: PropTypes.any,
  result: PropTypes.any,
  p: PolygotPropType,
  dimensions: PropTypes.string,
  noData: PropTypes.bool,
};

export default CMSReport(({
  startDate,
  endDate,
  dimensions,
  filters,
}) => ({
  name: 'CMS Report Dwell Time',
  startTime: startDate,
  endTime: endDate,
  metrics: 'dwelltime',
  dimensions,
  filters,
}))(CMSDwelltime);
